(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["soera-careers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-soc-role]');
    if (!link) return;
    var root = link.closest('.so-careers');
    if (!root) return;
    var select = root.querySelector('select[name="contact[role]"]');
    if (select) select.value = link.dataset.socRole;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soera-creator-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('soera-creator-carousel')) {
    customElements.define('soera-creator-carousel', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }
      setup() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        this.track = this.querySelector('.soera-creator-gallery__grid');
        this.controls = this.querySelector('.soera-creator-gallery__controls');
        this.previous = this.querySelector('[data-direction="previous"]');
        this.next = this.querySelector('[data-direction="next"]');
        if (!this.track || !this.controls || !this.previous || !this.next) return;
        const update = () => {
          const maximum = this.track.scrollWidth - this.track.clientWidth;
          const position = Math.abs(this.track.scrollLeft);
          this.controls.hidden = maximum <= 2;
          this.previous.disabled = position <= 2;
          this.next.disabled = position >= maximum - 2;
        };
        this.previous.addEventListener('click', () => this.move(-1), { signal: this.controller.signal });
        this.next.addEventListener('click', () => this.move(1), { signal: this.controller.signal });
        this.track.addEventListener('scroll', update, { passive: true, signal: this.controller.signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        }, { signal: this.controller.signal });
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.track);
        update();
      }
      move(direction) {
        const card = this.track.querySelector('.soera-creator-gallery__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const distance = card.getBoundingClientRect().width + gap;
        this.track.scrollBy({ left: distance * direction * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }
  if (!customElements.get('soera-creator-video')) {
    customElements.define('soera-creator-video', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        const button = this.querySelector('button');
        if (!button) return;
        button.addEventListener('click', () => {
          if (this.querySelector('iframe')) return;
          document.querySelectorAll('soera-creator-video.is-playing').forEach(other => {
            other.querySelector('iframe')?.remove();
            other.classList.remove('is-playing');
          });
          const template = this.querySelector('template');
          if (!template) return;
          this.append(template.content.cloneNode(true));
          this.classList.add('is-playing');
          this.querySelector('iframe')?.focus();
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soera-withdrawal"]) return;
  try {
    
document.querySelectorAll('[data-soera-withdrawal]').forEach(root => {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const copy = JSON.parse(root.querySelector('[data-sw-copy]').textContent);
  const form = root.querySelector('form'), review = root.querySelector('.sw-review'), success = root.querySelector('.sw-success');
  const confirm = root.querySelector('[data-confirm]'), edit = root.querySelector('[data-edit]'), error = root.querySelector('.sw-error');
  let data, receipt, submissionId, lastFingerprint, submitting = false;
  const fill = (target, rows) => {
    target.replaceChildren();
    rows.forEach(([label, value]) => { const dt = document.createElement('dt'), dd = document.createElement('dd'); dt.textContent = label; dd.textContent = value; target.append(dt, dd); });
  };
  const rows = () => [[copy.name, data.name], [copy.email, data.email], [copy.contract, data.contract], [copy.items, data.items || copy.entire]];
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (!form.reportValidity()) return;
    const fields = new FormData(form);
    data = { name: fields.get('name').trim(), email: fields.get('email').trim(), contract: fields.get('contract').trim(), items: fields.get('items').trim(), website: fields.get('website'), confirmed: true };
    const fingerprintBytes = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(JSON.stringify(data)));
    const fingerprint = Array.from(new Uint8Array(fingerprintBytes), byte => byte.toString(16).padStart(2, '0')).join('');
    try {
      const saved = JSON.parse(sessionStorage.getItem('soera-withdrawal-submission') || 'null');
      submissionId = saved && saved.fingerprint === fingerprint ? saved.id : (lastFingerprint === fingerprint && submissionId ? submissionId : crypto.randomUUID());
      sessionStorage.setItem('soera-withdrawal-submission', JSON.stringify({ fingerprint, id: submissionId }));
    } catch (storageError) {
      if (lastFingerprint !== fingerprint || !submissionId) submissionId = crypto.randomUUID();
    }
    lastFingerprint = fingerprint;
    fill(root.querySelector('[data-review-details]'), rows());
    form.hidden = true; review.hidden = false; error.hidden = true;
    root.querySelector('[data-step-two]').classList.add('sw-active');
    review.querySelector('h2').focus();
  });
  edit.addEventListener('click', () => {
    if (submitting) return;
    review.hidden = true; form.hidden = false; error.hidden = true;
    root.querySelector('[data-step-two]').classList.remove('sw-active');
    form.querySelector('input').focus();
  });
  confirm.addEventListener('click', async () => {
    if (submitting) return;
    submitting = true; confirm.disabled = true; edit.disabled = true; confirm.textContent = copy.sending; error.hidden = true;
    try {
      const response = await fetch(root.dataset.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...data, submission_id: submissionId }), signal: AbortSignal.timeout(45000) });
      const result = await response.json();
      if (!response.ok || result.status !== 'received' || !result.reference || !result.received_at) throw new Error(result.error || copy.error);
      receipt = result;
      fill(root.querySelector('[data-receipt-details]'), [...rows(), [copy.reference, receipt.reference], [copy.received, receipt.received_at]]);
      root.querySelector('[data-success-message]').textContent = (receipt.email_status === 'needs_review' ? copy.uncertain : copy.success).replace('[email]', data.email);
      review.hidden = true; success.hidden = false; success.querySelector('h2').focus();
    } catch (failure) {
      const message = failure.name === 'TimeoutError' || failure.name === 'TypeError' ? copy.error : failure.message;
      const parts = String(message).split('support@soera-store.com');
      error.replaceChildren();
      parts.forEach((part, index) => {
        if (index) {
          const emailLink = document.createElement('a');
          emailLink.href = 'mailto:support@soera-store.com';
          emailLink.textContent = 'support@soera-store.com';
          error.appendChild(emailLink);
        }
        error.appendChild(document.createTextNode(part));
      });
      error.hidden = false;
    } finally {
      submitting = false; confirm.disabled = false; edit.disabled = false; confirm.textContent = copy.confirm;
    }
  });
  root.querySelector('[data-download]').addEventListener('click', () => {
    if (!receipt) return;
    const text = 'SOERA\n\n' + copy.notice + '\n\n' + [...rows(), [copy.reference, receipt.reference], [copy.received, receipt.received_at]].map(([label, value]) => label + ': ' + value).join('\n') + '\n\nsupport@soera-store.com\n';
    const url = URL.createObjectURL(new Blob([text], { type: 'text/plain;charset=utf-8' }));
    const link = document.createElement('a'); link.href = url; link.download = 'SOERA-withdrawal-' + receipt.reference + '.txt'; link.click(); setTimeout(() => URL.revokeObjectURL(url), 1000);
  });
});

  } catch(e) { console.error(e); }
})();
})();
